import React from 'react';

const Offer = () => {
    return (
        <div>
            <h3>this is offer page </h3>
        </div>
    );
};

export default Offer;